import { createFileRoute } from "@tanstack/react-router";
import { GuestPage } from "@/components/app/meeting-guest/guest-page";

export const Route = createFileRoute("/join/$code")({
  component: JoinMeeting,
  head: () => ({
    meta: [
      { title: "Join a meeting" },
      { name: "robots", content: "noindex, nofollow" },
      // The code in the address is a credential. Nothing this page links to may learn it.
      { name: "referrer", content: "no-referrer" },
    ],
  }),
});

/** The page a person outside the organization opens from a meeting's guest link. */
function JoinMeeting() {
  const { code } = Route.useParams();
  return <GuestPage code={code} />;
}
